module.exports = __webpack_public_path__ + "img/logo2.e822da12.png";